import * as React from 'react';
import { User16, Phone16 } from '@cian/ui-kit';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
export function mapTypeToIcon(type) {
  switch (type) {
    case ERememberedAccountType.Email:
      return /*#__PURE__*/React.createElement(User16, {
        color: "gray60_100"
      });
    case ERememberedAccountType.Phone:
      return /*#__PURE__*/React.createElement(Phone16, {
        color: "gray60_100"
      });
    default:
      return null;
  }
}